import { Controller } from "@hotwired/stimulus"

// Owns the request state. It knows field names, not columns — adding a column is
// a Ruby-only change.
export default class extends Controller {
  static targets = ["form", "sort", "direction", "page"]
  static values = { debounce: { type: Number, default: 250 } }

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.reset(), this.debounceValue)
  }

  sort(event) {
    this.sortTarget.value = event.currentTarget.dataset.key
    this.directionTarget.value = event.currentTarget.dataset.direction
    this.reset()
  }

  paginate(event) {
    this.pageTarget.value = event.currentTarget.dataset.page
    this.submit()
  }

  // Back to page one, or a search run from page five comes back empty.
  reset() {
    this.pageTarget.value = 1
    this.submit()
  }

  submit() {
    this.formTarget.requestSubmit()
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
